import type { IPostalAddress } from '../customTypings/address/PostalAddress';

/** Normalizes postcode input for display and storage (UK postcodes are conventionally uppercase). */
export function normalizePostcodeInput(value: string): string {
  return value.toUpperCase();
}

export function formatPostalAddress(address: IPostalAddress | null | undefined): string {
  if (!address) return '';

  const parts: string[] = [];
  if (address.addressLine1) parts.push(address.addressLine1);
  if (address.addressLine2?.trim()) parts.push(address.addressLine2);
  if (address.addressLine3?.trim()) parts.push(address.addressLine3);
  if (address.town) parts.push(address.town);
  if (address.county?.trim()) parts.push(address.county);
  if (address.postcode) parts.push(address.postcode);
  if (address.country) parts.push(address.country);

  return parts.join(', ');
}

export function formatPostalAddressBlock(
  address: IPostalAddress | null | undefined,
  options?: { locationName?: string | null }
): string {
  const lines: string[] = [];
  const locationName = options?.locationName?.trim();
  if (locationName) lines.push(locationName);

  if (!address) return lines.join('\n');

  if (address.addressLine1) lines.push(address.addressLine1);
  if (address.addressLine2?.trim()) lines.push(address.addressLine2);
  if (address.addressLine3?.trim()) lines.push(address.addressLine3);
  if (address.town) lines.push(address.town);
  if (address.county?.trim()) lines.push(address.county);
  if (address.postcode) lines.push(address.postcode);
  if (address.country) lines.push(address.country);

  return lines.join('\n');
}

/** @deprecated Use formatPostalAddress */
export function formatAddress(address: { line1?: string; line2?: string; line3?: string; town?: string; county?: string; postcode?: string; country?: string } | null | undefined): string {
  return formatPostalAddress({
    addressLine1: address?.line1,
    addressLine2: address?.line2,
    addressLine3: address?.line3,
    town: address?.town,
    county: address?.county,
    postcode: address?.postcode,
    country: address?.country,
  });
}